import * as React from "react";
import {
  Icon,
  //from "../../../../personal-studio-components/frame/index.js";
} from "../frame/index.js";
import { TableModel, SortingOrder, ColumnType } from "./TableModel.js";
import * as cls from "./Table.module.scss";
import ascIcon from "./Table.asc.svg";
import descIcon from "./Table.desc.svg";
export { TableView };
/**
 * Вид таблицы.
 * @property {Object} props - Атрибуты элемента.
 * @property {TableModel} props.model - Модель таблицы.
 * @extends {React.Component}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class TableView extends React.Component {
  counter = 0;
  /**
   * Отображает компонент.
   * @returns {JSX.Element} Элемент JSX.
   */
  render() {
    const model = new TableModel(this.props.model);
    const th = model.columns.map((th) => this.renderTH(th));
    const tr = model.rows.map((tr) => this.renderTR(tr, model));
    const style = { maxHeight: model.maxHeight };
    return (
      <div className={cls.table_container} style={style}>
        <table className={cls.table}>
          <thead>
            <tr>{th}</tr>
          </thead>
          <tbody>{tr}</tbody>
        </table>
      </div>
    );
  }
  renderTH({
    field,
    type = "string",
    headerName,
    hide,
    sortable,
    sortingOrder,
    onSort,
  }) {
    if (hide) return null;
    const name = headerName ?? field;
    const className = cls["th_" + type];
    if (sortable) {
      const ascClassName =
        SortingOrder.ASC == sortingOrder
          ? cls.th_sort_icon_active
          : cls.th_sort_icon;
      const descClassName =
        SortingOrder.DESC == sortingOrder
          ? cls.th_sort_icon_active
          : cls.th_sort_icon;
      return (
        <th onClick={onSort} key={++this.counter} className={className}>
          <div className={cls.th_sortable}>
            <div className={cls.th_header}>{name}</div>
            <div className={cls.th_sort}>
              <img className={ascClassName} src={ascIcon} />
              <img className={descClassName} src={descIcon} />
            </div>
          </div>
        </th>
      );
    } else {
      return (
        <th key={++this.counter} className={className}>
          <div className={cls.th_header}>{name}</div>
        </th>
      );
    }
  }
  renderTR(tr, table) {
    const td = table.columns.map((th) => this.renderTD(tr[th.field], th, tr));
    const style = tr.onClick ? { cursor: "pointer" } : undefined;
    return (
      <tr key={++this.counter} onClick={tr.onClick} style={style}>
        {td}
      </tr>
    );
  }
  renderTD(td, th, tr) {
    if (th.hide) return null;
    const name = th.headerName ?? th.field;
    const type = th.type ?? "string";
    const className = cls["td_" + type];
    let view = "";
    if (null != td && "" !== td)
      view = (
        <>
          <div className={cls.td_header}>{name}</div>
          <div className={cls.td_data}>{this.renderData(td, th, tr)}</div>
        </>
      );
    return (
      <td key={++this.counter} className={className}>
        {view}
      </td>
    );
  }
  //https://mui.com/x/react-data-grid/column-definition/#column-types
  renderData(td, th, tr) {
    if (null == td) return "";
    switch (th.type) {
      case ColumnType.BOOLEAN:
        return this.renderBoolean(td, th, tr);
      case ColumnType.NUMBER:
        return this.renderNumber(td, th, tr);
      case ColumnType.DATE:
        return this.renderDate(td, th, tr);
      case ColumnType.DATE_TIME:
        return this.renderDateTime(td, th, tr);
      case ColumnType.LINK:
        return this.renderLink(td, th, tr);
      case ColumnType.IMG:
        return this.renderImg(td, th, tr);
      case ColumnType.FILE:
        return this.renderFile(td, th, tr);
      case ColumnType.HTML:
        return this.renderHTML(td, th, tr);
      case ColumnType.JSX:
        return this.renderJSX(td, th, tr);
      default:
        return this.renderString(td, th, tr);
    }
  }
  renderString(td) {
    return String(td);
  }
  renderBoolean(td) {
    return <Icon name={td ? "check" : "close_circle"} />;
  }
  renderNumber(td) {
    if ("number" !== typeof td) return String(td);
    return new Number(td).toLocaleString();
  }
  renderDate(td) {
    const view = new Date(td).toLocaleDateString();
    if ("Invalid Date" == view) return String(td);
    return view;
  }
  renderDateTime(td) {
    const hasZeroTime = /00:00:00/.test(td);
    let view = hasZeroTime
      ? new Date(td).toLocaleDateString()
      : new Date(td).toLocaleString();
    if ("Invalid Date" == view) return String(td);
    return view;
  }
  renderLink(td) {
    const { name, href, target, download, onClick } = td;
    return (
      <a
        href={href}
        target={target}
        download={download}
        onClick={onClickWrapper}
      >
        {name}
      </a>
    );
    function onClickWrapper(event) {
      if (onClick) {
        event.preventDefault();
        onClick(td);
      }
    }
  }
  renderImg(td) {
    const { name, src, href, target, download, onClick } = td;
    const img = <img src={src} alt={name} title={name} />;
    if (!href && !onClick) return img;
    return (
      <a
        href={href}
        target={target}
        download={download}
        onClick={onClickWrapper}
      >
        {img}
      </a>
    );
    function onClickWrapper(event) {
      if (onClick) {
        event.preventDefault();
        onClick(td);
      }
    }
  }
  renderFile(td) {
    const { name, mime_type, preview, href, target, download, onClick } = td;
    const icon = this.getMimeIcon(mime_type);
    return (
      <a
        className={cls.td_file_link}
        href={href}
        target={target}
        download={download}
        onClick={onClickWrapper}
      >
        {preview ? (
          <div className={cls.td_file_preview}>
            <img src={preview} />
          </div>
        ) : null}
        <div className={cls.td_file_label}>
          <Icon name={icon} className={cls.td_file_label_icon} />{" "}
          <span className={cls.td_file_label_text}>{name}</span>
        </div>
      </a>
    );
    function onClickWrapper(event) {
      if (onClick) {
        event.preventDefault();
        onClick(td);
      }
    }
  }
  getMimeIcon(mime_type) {
    if ("inode/directory" == mime_type) return "folder_open";
    if (/^video\//.test(mime_type)) return "video_file";
    return "file";
  }
  renderHTML(td) {
    return (
      <div
        className={cls.td_html_container}
        dangerouslySetInnerHTML={{ __html: String(td) }}
      />
    );
  }
  renderJSX(td) {
    return td;
  }
}
